import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import {
  getIsExpired,
  isRedirectedToFeaturePage,
  setRedirectedToFeaturePageFlag,
} from 'helpers/boost';
import { isMonetizationPage } from 'helpers/route';
import { setBoostEpireDate } from 'store/common/commonSlice';
import { getBoostEpireDateSelector } from 'store/common/selectors';

const EXPIRED_POLLING_INTERVAL = 30 * 1000;

/**
 * The purpose of this hook is to check is boost expired and when it does
 * 1) Set expiration time in store into null
 * 2) Redirect to buy boost page
 */
export const useBoostExpire = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const boostExpiredAt = useSelector(getBoostEpireDateSelector);

  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null;

    function updateExpiration() {
      if (boostExpiredAt === null) {
        return;
      }

      if (getIsExpired(boostExpiredAt)) {
        dispatch(setBoostEpireDate(null));

        if (
          !isRedirectedToFeaturePage() &&
          !isMonetizationPage(location.pathname)
        ) {
          history.push('/featured');
          setRedirectedToFeaturePageFlag();
        }
      }
    }

    updateExpiration();

    intervalId = setInterval(updateExpiration, EXPIRED_POLLING_INTERVAL);

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [boostExpiredAt, dispatch, history, location.pathname]);
};
